import styled from 'styled-components'

export const DetailListContainer = styled.div``
